module.exports = __webpack_public_path__ + "static/battle_15-3a9c0df2da040cae46b69accded163e4.jpg";